module.exports = __webpack_public_path__ + "img/close.50b6c092.png";